<mat-card style="border-color: #5775a8;">
  <mat-card-header cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="background-color: #5775a8;">
    <div class="flex flex-row rounded-lg w-full" style="align-items: center;">
      <div class="flex flex-col w-full" style="padding-right: 20px;">
        <span style="color: white;">
          Comments added here will be available to all complaints for this business:
          <b>{{currentBusiness.businessName}}</b>
        </span>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <form [formGroup]="form">
      <div class="flex flex-col" style="padding: 1%;">
        <mat-form-field class="w-full">
          <mat-label>Business Comment</mat-label>
          <textarea matInput cdkTextareaAutosize formControlName="businessComments" cdkAutosizeMinRows="4"></textarea>
        </mat-form-field>

        <div class="flex flex-row ">
          <div style="padding-right: 20px;">
            <button mat-raised-button (click)="save()" class="m-8 container" style="background: #7ABDF3;">
              <mat-icon>save</mat-icon> Save
            </button>
          </div>
          <div style="padding-right: 20px;">
            <button mat-raised-button (click)="return()" class="m-8 container">
              Return
            </button>
          </div>
        </div>
      </div>
    </form>

  </mat-card-content>

</mat-card>